<template lang="pug">
  .hint-wrap
    .caption.d-flex.align-center.pb-3(v-if="hintDescription")
      v-icon(small) mdi-information-outline
      .ml-2 {{ hintDescription }}
    component(
      :is="component"
      :value="value"
      v-bind="$attrs"
      v-on="$listeners"
    )
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: { default: null },
    component: { type: [String, Object], default: null },
    hintDescription: { type: String, default: null },
  },
};
</script>
